(function($) {
    "use strict";

    var w = {};

    w.width = $(window).width();

    var wb = {
        captures: {
            test: function() {
                return $('.capture').length;
            },
            run: function() {
                const FADE = 400;
                const STORAGE_KEY = 'mc-email';
                const STORAGE_VALUE = '1';
                if(localStorage.getItem(STORAGE_KEY) !== STORAGE_VALUE) {
                    $('.capture').fadeIn(FADE);
                    $('#capture-mailchimp').on('submit', function(e) {
                        e.preventDefault();
                        localStorage.setItem(STORAGE_KEY, STORAGE_VALUE);
                        $('.capture').fadeOut(FADE, function() {
                            $.ajax({
                                method: "POST",
                                url: launchframe.ajax_url+'?action=email_capture',
                                data: $('#capture-mailchimp').serialize()
                            })
                            .done(function(data) {
                                $('.capture').remove();
                            });
                        });
                    });
                } else {
                    $('.capture').remove();
                }
            }
        }
    };

    function runObject() {
        for (var key in wb) {
            if (wb[key].test()) {
                wb[key].run();
            }
        }
    }

    runObject();

}(jQuery));

// Slide open a div
function showStuff(id) {
    if (jQuery('#' + id).css("display") === 'flex'){
        jQuery('#' + id).slideUp();
    } else {
        jQuery('#' + id).slideDown();
    }
}

// Slide left and right
jQuery(document).ready(function(){
    var menuWidth = jQuery(".main-menu").width();
    jQuery(".menu-close").click(function(){
        jQuery(".main-menu").animate({width: 0},"fast");
    });
    jQuery(".menu-open").click(function(){
        jQuery(".main-menu").animate({width: 320},"fast");
    });
});



// WEBPACK FOOTER //
// ./assets/src/js/script.js